import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from 'ng2-ckeditor';
// import { AngularDateTimePickerModule } from 'angular2-datetimepicker';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CkeditorComponent } from './ckeditor/ckeditor.component';
import { DatetimepickerComponent } from './datetimepicker/datetimepicker.component';
import { InboxComponent } from './inbox/inbox.component';
import { FilterPipe } from './pipes/filter.pipe';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ButtonDatetimepickerComponent } from './button-datetimepicker/button-datetimepicker.component';
import { FormsModule } from '@angular/forms';
import { PeerEvaluationGridComponent } from './peer-evaluation-grid/peer-evaluation-grid.component';
import { SortPipe } from './pipes/sort.pipe';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { TooltipModule } from 'ngx-tooltip';
import { ViewCourseModalComponent } from '../layout/modules/admin/programme/programme-details/modals/view-course-modal/view-course-modal.component';
import { UploadedFileViewComponent } from '../layout/modules/admin/programme/shared/uploaded-file-view/uploaded-file-view.component';
import { ViewExamModalComponent } from '../layout/modules/admin/programme/programme-details/modals/view-exam-modal/view-exam-modal.component';
import { ViewDiplomaPaperModalComponent } from '../layout/modules/admin/programme/programme-details/modals/view-diploma-paper-modal/view-diploma-paper-modal.component';
import { FindObjPipe } from './pipes/find-obj.pipe';
import { NumberInputDirective } from './directives/number-input.directive';
import { NgSelectIsOpenDirective } from './directives/ng-select-is-open.directive';
import { FileExtValidatorDirective } from './directives/file-ext-validator.directive';
import { UiSwitchModule } from 'ngx-ui-switch';
import { VideoUploadComponent } from './video-upload/video-upload.component';
import { VideoLinkUploadModalComponent } from './video-upload/video-link-upload-modal/video-link-upload-modal.component';
import { ViewVideoModalComponent } from './view-video-modal/view-video-modal.component';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { LinkUploadComponent } from './link-upload/link-upload.component';
import { LinkUploadInputModalComponent } from './link-upload-input-modal/link-upload-input-modal.component';
import { StudentNamePipe } from './pipes/student-name.pipe';
import { AddExchangeStudentModalComponent } from '../layout/modules/admin/programme/programme-details/modals/add-exchange-student-modal/add-exchange-student-modal.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RegisterStudentModalComponent } from '../layout/modules/admin/programme/programme-details/modals/register-student-modal/register-student-modal.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CKEditorModule,
    // AngularDateTimePickerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TooltipModule,
    UiSwitchModule,
    MalihuScrollbarModule.forChild(),
    InfiniteScrollModule,
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CkeditorComponent,
    DatetimepickerComponent,
    InboxComponent,
    FilterPipe,
    ButtonDatetimepickerComponent,
    PeerEvaluationGridComponent,
    SortPipe,
    FileUploadComponent,
    UploadedFileViewComponent,

    ViewCourseModalComponent,
    ViewExamModalComponent,
    ViewDiplomaPaperModalComponent,
    FindObjPipe,
    NumberInputDirective,
    NgSelectIsOpenDirective,
    FileExtValidatorDirective,
    VideoUploadComponent,
    VideoLinkUploadModalComponent,
    ViewVideoModalComponent,
    LinkUploadComponent,
    LinkUploadInputModalComponent,
    StudentNamePipe,
    AddExchangeStudentModalComponent,
    RegisterStudentModalComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CkeditorComponent,
    DatetimepickerComponent,
    InboxComponent,
    FilterPipe,
    SortPipe,
    ButtonDatetimepickerComponent,
    PeerEvaluationGridComponent,
    FileUploadComponent,
    UploadedFileViewComponent,

    ViewCourseModalComponent,
    ViewExamModalComponent,
    ViewDiplomaPaperModalComponent,
    FindObjPipe,
    NumberInputDirective,
    NgSelectIsOpenDirective,
    FileExtValidatorDirective,
    VideoUploadComponent,
    ViewVideoModalComponent,
    LinkUploadComponent,
    LinkUploadInputModalComponent,
    StudentNamePipe,
    AddExchangeStudentModalComponent,
    RegisterStudentModalComponent
  ],
  entryComponents: [VideoLinkUploadModalComponent, ViewVideoModalComponent]
})
export class SharedModule { }



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/shared.module.ts